import React from 'react';
import { useSelector } from 'react-redux';

// use in main layout
const LoadingSpinner = () => {

  const headerAnimation=(
    <div className="flex flex-row justify-center items-center space-x-2 w-1/3 h-1/3 fixed">
      <div className="nav-icon text-2xl flex items-end justify-center w-8 h-8 space-x-0.5 relative">
        {[
          { height: '60%', delay: '-0.4s', bg: 'from-blue-800 to-blue-400' },
          { height: '90%', delay: '-0.2s', bg: 'from-blue-700 to-sky-400' },
          { height: '75%', delay: '0s',    bg: 'from-blue-900 to-blue-600' },
          
        ].map((bar, idx) => (
          <div
            key={idx}
            className={`w-[3px] rounded-sm animate-candle bg-gradient-to-t ${bar.bg}`}
            style={{
              height: bar.height,
              animationDelay: bar.delay,
            }}
          />
        ))}
      </div>
      <h1 className="text-xl font-bold text-text-primary mt-2">7 trade</h1>
    </div>
  )

 const Flag=useSelector((state)=>state.loading.global)
 
  return (
    <>
    {
        Flag &&
    <div className="flex fixed items-center justify-center min-h-screen z-50 w-full backdrop-blur-sm">
      {headerAnimation}
    </div>
    }
    </>
  );
};

export default LoadingSpinner;